import templateUrl from 'emun.salesrep/salesrep-sales-show-code.htm';
import salesrepConfig from 'emun.salesrep/salesrep.config'

class SalesRepSalesShowCodeController {
  constructor($window, $rootScope, retailerPrompt, createAutoQuery) {
    let $ctrl = this;
    $ctrl.orderByField = 'label';
    $ctrl.reverseSort = false;
    $ctrl.mode = "list";
    $ctrl.total = 0;
    $ctrl.repGroupFilter = '';
    $ctrl.label = $ctrl.title || "Source";
    if ($ctrl.repGroup !== 'ALL') {
      $ctrl.repGroupFilter = '&RepGroupName=' + $ctrl.repGroup;
    }
    $ctrl.colors = salesrepConfig.chartColors;
    $ctrl.chartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          boxWidth: 5,
          fontSize: 10
        }
      },
      elements: {
        rectangle: {
          borderWidth: 1
        }
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.labels[tooltipItem.index];
            let datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "  (" + Math.round(((datasetLabel / $ctrl.total) * 100)) + '%)';
          }
        }
      }
    };
    var context = $ctrl.context || 'rep';

    var filter = "SalesRepID";
    if (context === 'manager') { filter = "ManagerId"; }
    if (context === 'category') { filter = "CategoryId"; }
    if ($ctrl.context === 'executive') { filter = ''; }

    $ctrl.results = [];

    var salesQueryUrl = 'QuerySalesYOYTotals.json?Sum=TotalSalesMonthToDate,TotalSalesQuarterToDate,TotalSalesYearToDate,TotalSalesMonthToDateLastYear,TotalSalesQuarterToDateLastYear,TotalSalesYearToDateLastYear,TotalSalesLastYear&GroupBy=ShowCode&OrderBy=ShowCode';
    if ($ctrl.repGroup) {
      if ($ctrl.repGroup !== 'ALL') {
        salesQueryUrl = salesQueryUrl + '&RepGroupName=' + $ctrl.repGroup;
      }
    }
    if (context === 'writingRep') {
      if ($ctrl.salesRepId) {
        salesQueryUrl = salesQueryUrl + '&SalesRepID=' + $ctrl.salesRepId;
        filter = '';
      }
      else {
        if ($ctrl.writingRepId) {
          salesQueryUrl = salesQueryUrl + '&WritingRepID=' + $ctrl.writingRepId;
          filter = '';
        }
      }
    }
    else {
      if (filter !== '') {
        salesQueryUrl = salesQueryUrl + '&' + filter + '=' + $ctrl.rep.id;
      }
    }
    if ($ctrl.insideSales === 'true') {
      salesQueryUrl = salesQueryUrl + '&IsInsideSales=true';
    }

    //console.debug(salesQueryUrl);
    $ctrl.salesQuery = createAutoQuery({
      url: salesQueryUrl,
      pageSize: 1000,
      autoLoad: false,
      onLoaded: function (args) {
        $ctrl.chartLabels = [];
        $ctrl.chartData = [];
        $ctrl.ytdTotal = 0;
        $ctrl.lastytdTotal = 0;
        $ctrl.lastyearTotal = 0;
        $ctrl.quarterTotal = 0;
        $ctrl.quarterlytdTotal = 0;
        $ctrl.mtdTotal = 0;
        $ctrl.lastmtdTotal = 0;
        $ctrl.totalYearGoal = 0;
        $ctrl.totalMonthGoal = 0;

        args.results.forEach(function (sales) {
          if (sales.sumTotalSalesYearToDate > 0) {
            $ctrl.ytdTotal += sales.sumTotalSalesYearToDate;
          }
          if (sales.sumTotalSalesYearToDateLastYear > 0) {
            $ctrl.lastytdTotal += sales.sumTotalSalesYearToDateLastYear;
          }
          if (sales.sumTotalSalesLastYear > 0) {
            $ctrl.lastyearTotal += sales.sumTotalSalesLastYear;
          }
          if (sales.sumTotalSalesQuarterToDate > 0) {
            $ctrl.quarterTotal += sales.sumTotalSalesQuarterToDate;
          }
          if (sales.sumTotalSalesQuarterToDateLastYear > 0) {
            $ctrl.quarterlytdTotal += sales.sumTotalSalesQuarterToDateLastYear;
          }
          if (sales.sumTotalSalesMonthToDate > 0) {
            $ctrl.mtdTotal += sales.sumTotalSalesMonthToDate;
          }
          if (sales.sumTotalSalesMonthToDateLastYear > 0) {
            $ctrl.lastmtdTotal += sales.sumTotalSalesMonthToDateLastYear;
          }
        });
        $ctrl.sales = [];
        args.results.forEach(function (sales) {
              
          sales.ytdTotal = sales.sumTotalSalesYearToDate;
          sales.lastyearTotal = sales.sumTotalSalesLastYear;
          sales.lastytdTotal = sales.sumTotalSalesYearToDateLastYear;
          sales.quarterTotal = sales.sumTotalSalesQuarterToDate;
          sales.quarterlytdTotal = sales.sumTotalSalesQuarterToDateLastYear;
          sales.mtdTotal = sales.sumTotalSalesMonthToDate;
          sales.lastmtdTotal = sales.sumTotalSalesMonthToDateLastYear;
          sales.ytdSourcePercent = 0;
          sales.lastyearSourcePercent = 0;
          sales.lastytdSourcePercent = 0;
          sales.ytdSourcePercent = Math.round((sales.ytdTotal / $ctrl.ytdTotal) * 100);
          //console.debug("cat info", v.label, v.ytdTotal, $ctrl.lastytdTotal);
          sales.lastyearSourcePercent = Math.round((sales.ytdTotal / $ctrl.lastyearTotal) * 100);
          sales.lastytdSourcePercent = Math.round((sales.ytdTotal / $ctrl.lastytdTotal) * 100);
          $ctrl.chartLabels.push(sales.source);
          $ctrl.chartData.push(Math.round(sales.ytdTotal));
          $ctrl.total += sales.ytdTotal;
          $ctrl.sales.push(sales);
        });
        //console.info("$ctrl.sales", $ctrl.quarterTotal);
        $ctrl.isBusy = false;
      }
    });

    $ctrl.isBusy = true;
    $ctrl.salesQuery.load(true);
  }
}

let SalesRepSalesShowCode = {
  bindings: {
    rep: '<',
    repGroup: '@',
    context: '@',
    title: '@',
    insideSales: '@',
    writingRepId: '@',
    salesRepId: '@'
  },
  controller: SalesRepSalesShowCodeController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};

export default SalesRepSalesShowCode